import { formatMessage, IconPath } from 'cw-ui-core';
import Locale from 'src/i18n';

export const ACTIONS = {
    RESET_PASSWORD_ID: 'RESET_PASSWORD',
    DISABLE_ACCOUNT_ID: 'DISABLE_ACCOUNT',
    RESEND_INVITE_ID: 'RESEND_INVITE',
    ENABLE_ACCOUNT_ID: 'ENABLE_ACCOUNT',
    AUTH_APP_RESET_ID: 'AUTH_APP_RESET',
    CUSTOM_APP_ROLE_ASSIGNMENT_CHANGED_ID: 'CUSTOM_APP_ROLE_ASSIGNMENT_CHANGED_ID',
};

export const RESET_PASSWORD = {
    id: ACTIONS.RESET_PASSWORD_ID,
    value: formatMessage(Locale.resetPassword),
    icon: IconPath.get('Status_Unlocked'),
    confirmationMessage: formatMessage(Locale.resetPasswordMessage),
    tooltipMessage: formatMessage(Locale.resetPasswordTooltipMessage),
};
export const DISABLE_ACCOUNT = {
    id: ACTIONS.DISABLE_ACCOUNT_ID,
    value: formatMessage(Locale.disableAccount),
    icon: IconPath.get('Action_Ignore'),
    confirmationMessage: formatMessage(Locale.disableUserAlert),
    tooltipMessage: formatMessage(Locale.disableUserTooltipMessage),
};
export const RESEND_INVITE = {
    id: ACTIONS.RESEND_INVITE_ID,
    value: formatMessage(Locale.resendInvite),
    icon: IconPath.get('Action_email'),
    confirmationMessage: formatMessage(Locale.resendInviteMessage),
    tooltipMessage: formatMessage(Locale.resendInviteTooltipMessage),
};
export const ENABLE_ACCOUNT = {
    id: ACTIONS.ENABLE_ACCOUNT_ID,
    value: formatMessage(Locale.enableAccount),
    icon: IconPath.get('Flag_Enabled'),
    confirmationMessage: formatMessage(Locale.enableAccountMessage),
    tooltipMessage: formatMessage(Locale.enableUserTooltipMessage),
};

export const AUTH_APP_RESET = {
    id: ACTIONS.AUTH_APP_RESET_ID,
    confirmationMessage: formatMessage(Locale.resetAuthAppMFAConfirmation),
};

export const CUSTOM_APP_ROLE_CHANGED = {
    id: ACTIONS.CUSTOM_APP_ROLE_ASSIGNMENT_CHANGED_ID,
    confirmationMessage: formatMessage(Locale.customRoleChangedConfirmationMessage),
};

const calculateStatus = status => {
    let statusValue;
    let statusColor;
    const actions = [];
    if (status === 'disabled') {
        statusValue = formatMessage(Locale.disabled);
        statusColor = '#7d7d7d';
        actions.push(ENABLE_ACCOUNT, RESEND_INVITE);
    } else if (status === 'active') {
        statusValue = formatMessage(Locale.userStatusActive);
        statusColor = '#549c05';
        actions.push(RESET_PASSWORD, DISABLE_ACCOUNT);
    } else if (status === 'pending') {
        statusValue = formatMessage(Locale.userStatusPending);
        statusColor = '#eb7b18';
        actions.push(RESEND_INVITE, DISABLE_ACCOUNT);
    } else if (status === 'expired') {
        statusValue = formatMessage(Locale.expired);
        statusColor = '#ca001a';
        actions.push(RESEND_INVITE, DISABLE_ACCOUNT);
    }
    return [statusValue, statusColor, actions];
};

export default calculateStatus;
